<template>
  <div class="mt-lg-24">
    <Review
      v-for="review in reviews"
      :key="review.reviewUid"
      :review="review"
      :book-title="bookTitle"
      :report-review="reportReview"
      :logged-in-user="loggedInUser"
      :open-login-drawer="openLoginDrawer"
      :like-review="likeReview"
      :remove-like="removeLike"
      :delete-review="deleteReview"
      :update-reviews="updateReviews"
    />
  </div>
</template>

<script>
import Review from '~/components/reviews/Review'

export default {
  components: {
    Review,
  },
  props: {
    reviews: {
      type: Array,
      required: true,
    },
    bookTitle: {
      type: String,
      required: true,
    },
    reportReview: {
      type: Function,
      required: true,
    },
    loggedInUser: {
      type: [Object, Boolean],
      default: false,
    },
    openLoginDrawer: {
      type: Function,
      required: true,
    },
    likeReview: {
      type: Function,
      required: true,
    },
    removeLike: {
      type: Function,
      required: true,
    },
    deleteReview: {
      type: Function,
      required: true,
    },
    updateReviews: {
      type: Function,
      required: true,
    },
  },
}
</script>
